import { Button } from "@/components/ui/button";
import Link from "next/link";

export const DigitalOceanReferral = () =>
  process.env.NEXT_PUBLIC_DO_REFERRAL_LINK ? (
    <div className="flex flex-col sm:flex-row justify-between gap-4 items-center w-full">
      <div className="flex flex-row xl:flex-row lg:flex-col md:flex-row gap-4 items-center w-full sm:w-auto">
        <Link
          className="inline-block h-10 shrink-0"
          href={process.env.NEXT_PUBLIC_DO_REFERRAL_LINK}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/assets/provider/do-banner.svg"
            alt="DigitalOcean Referral Badge"
            className="h-10 object-contain rounded-md"
          />
        </Link>
        <div className="text-sm">Register with DigitalOcean and get $200 in credit.</div>
      </div>
      <Button asChild className="w-full sm:w-auto">
        <Link
          href={process.env.NEXT_PUBLIC_DO_REFERRAL_LINK}
          target="_blank"
          rel="noopener noreferrer"
        >
          Create an account
        </Link>
      </Button>
    </div>
  ) : null;
